export enum FACEBOOK_STATUS {
    CONNECTED = "connected",
    NOT_AUTHORIZED = "not_authorized",
    UNKNOWN = "unknown"
}